import styled from "styled-components"

const Div = styled.div`
    padding: 200px 10% 5%;

    @media (max-width: 768px) {
        padding: 130px 10% 5%;
    }
`

function Error() {
    return (
        <Div>
            <h1>Cette page n'existe pas 🦁</h1>
        </Div>
    )
}

export default Error
